import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedAdminRoute({ children }) {
  const token = localStorage.getItem("token");

  // 🔒 Se não houver token → redireciona para login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  let role = null;

  try {
    const decoded = jwtDecode(token);
    role = decoded.role;
  } catch (err) {
    console.error("Erro ao decodificar token:", err);
    return <Navigate to="/login" replace />;
  }

  // 👮 Se não for admin → nega acesso
  if (role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // 👍 Admin autenticado → deixa entrar
  return children;
}
